export const FavoritesEmptyNewsList = () => {
  return (
    <svg
      width="141"
      height="140"
      viewBox="0 0 141 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5096 103.008C20.9886 103.125 20.6166 103.574 20.6029 104.113C20.5715 105.168 20.5363 106.315 20.5091 107.198C20.4955 107.64 20.4834 108.015 20.4752 108.28C20.4731 108.349 20.4715 108.411 20.4698 108.465C20.4221 108.489 20.3669 108.518 20.3049 108.55C20.069 108.671 19.7353 108.844 19.3426 109.046C18.557 109.45 17.5359 109.974 16.5966 110.456L16.5976 110.456C16.1296 110.695 15.8711 111.224 15.99 111.75C16.1065 112.266 16.5666 112.642 17.0949 112.657L17.0942 112.658C18.1494 112.69 19.2967 112.724 20.1797 112.751C20.6211 112.765 20.9965 112.777 21.2616 112.785C21.3313 112.787 21.3934 112.789 21.447 112.79C21.4715 112.838 21.4994 112.893 21.5312 112.954C21.6524 113.19 21.8246 113.523 22.0265 113.915C22.4303 114.699 22.9544 115.72 23.4372 116.663C23.6768 117.131 24.2054 117.389 24.7318 117.27C25.2473 117.154 25.6243 116.693 25.6395 116.165C25.6699 115.106 25.7045 113.959 25.7319 113.078C25.7456 112.637 25.7579 112.262 25.7663 111.998C25.7685 111.928 25.7709 111.866 25.7726 111.813C25.8201 111.789 25.8752 111.761 25.9368 111.729C26.1727 111.607 26.5072 111.435 26.9 111.233C27.6856 110.829 28.706 110.305 29.645 109.823C30.1153 109.582 30.369 109.043 30.2526 108.528C30.1337 108.002 29.6729 107.636 29.1475 107.621C28.0925 107.589 26.9459 107.555 26.0629 107.527C25.6214 107.514 25.2452 107.502 24.98 107.494C24.9106 107.492 24.8488 107.489 24.7954 107.487C24.7709 107.44 24.742 107.385 24.7103 107.323C24.5889 107.088 24.4165 106.754 24.2145 106.361C23.8104 105.576 23.2862 104.554 22.8043 103.615C22.5591 103.132 22.0198 102.892 21.5096 103.008Z"
        fill="#99BCFF"
        stroke="url(#paint0_linear_24407_9630)"
        strokeWidth="0.797921"
      />
      <g filter="url(#filter0_dd_24407_9630)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.993 81.9428L88.478 80.4735C88.478 80.4735 84.4269 103.666 82.4768 114.829C82.2113 116.332 82.5966 117.883 83.5228 119.086C84.4642 120.302 85.8586 121.061 87.3853 121.192C88.0083 121.242 88.6314 121.292 89.2304 121.34C91.782 121.561 94.1285 119.981 94.883 117.541C98.0633 107.336 105.993 81.9428 105.993 81.9428Z"
          fill="#99BCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.7032 47.8952C56.4199 48.5443 62.1548 55.3313 61.5082 63.0449C60.8605 70.7601 54.0725 76.4992 46.3558 75.8502C38.6403 75.1997 32.9043 68.4142 33.552 60.699C34.1998 52.9838 40.9865 47.2462 48.7032 47.8952Z"
          fill="#85AAF2"
        />
        <foreignObject
          x="-5.53125"
          y="-25.6851"
          width="173.695"
          height="175.263"
        >
          <div
            style={{
              clipPath: 'url(#bgblur_0_24407_9630_clip_path)',
              height: '100%',
              width: '100%',
            }}
          ></div>
        </foreignObject>
        <path
          data-figma-bg-blur-radius="44"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.7281 104.535L43.6947 104.367C41.1443 104.145 39.2691 101.921 39.4862 99.3897C40.7189 84.5948 44.6095 38.3301 45.8436 23.5337C46.0606 21.0021 48.28 19.1105 50.8304 19.3327C51.499 19.3895 52.1915 19.4481 52.8638 19.5002C56.0638 19.7712 59.0231 21.2978 61.0943 23.7492C61.0943 23.7492 71.1153 35.6059 75.5567 40.8595C76.8768 42.4226 78.7766 43.4049 80.8138 43.5678C89.4859 44.2975 103.916 45.5112 103.916 45.5112C115.48 46.483 124.063 56.6394 123.088 68.2006C123.102 68.2146 123.1 68.2177 123.1 68.2177C122.125 79.7788 111.969 88.3709 100.406 87.3991C100.406 87.3991 85.9758 86.1854 77.3037 85.4558C75.2513 85.2803 73.2296 85.9372 71.6569 87.2597C66.4025 91.6928 54.555 101.721 54.555 101.721C52.0916 103.785 48.928 104.806 45.7281 104.535Z"
          fill="url(#paint1_radial_24407_9630)"
          stroke="url(#paint2_linear_24407_9630)"
          strokeWidth="2"
        />
      </g>
      <path
        d="M12.8249 15.4708C12.0076 15.6175 11.398 16.2871 11.3394 17.1233C11.2173 18.76 11.0829 20.539 10.9793 21.9085C10.9276 22.5931 10.884 23.1759 10.8528 23.5871C10.8446 23.6948 10.8371 23.7908 10.8308 23.8738C10.755 23.9086 10.6671 23.949 10.5686 23.9942C10.1938 24.1664 9.66283 24.4107 9.03882 24.6972C7.79078 25.2702 6.16979 26.0136 4.67781 26.6967L4.54235 26.7657C3.882 27.1367 3.50494 27.8907 3.64383 28.6651C3.77989 29.4229 4.39404 30.0125 5.14531 30.133L5.29725 30.1504C6.93373 30.2725 8.71207 30.4071 10.0815 30.5107C10.7661 30.5625 11.3488 30.606 11.7601 30.6372C11.8681 30.6454 11.9646 30.6528 12.0478 30.6591C12.0824 30.7344 12.1228 30.8215 12.1679 30.9193C12.3398 31.293 12.583 31.8232 12.8694 32.4464C13.442 33.6928 14.1855 35.3138 14.8698 36.8122L14.8707 36.812C15.2104 37.5554 16.0123 37.9932 16.8379 37.8452C17.6466 37.7002 18.264 37.0118 18.3244 36.1926C18.4453 34.5498 18.5789 32.7714 18.6828 31.4037C18.7348 30.7199 18.7795 30.138 18.8109 29.7278C18.8191 29.6204 18.8267 29.5248 18.833 29.4421C18.9087 29.4073 18.996 29.3669 19.0942 29.3218C19.469 29.1496 20.0002 28.9063 20.6242 28.6198C21.8724 28.0467 23.4938 27.3024 24.986 26.6191L24.9858 26.6182C25.7327 26.2766 26.164 25.4601 26.0192 24.6519C25.8711 23.8261 25.1816 23.2257 24.3666 23.1654L19.5815 22.8063C18.8968 22.7545 18.314 22.71 17.9028 22.6788C17.795 22.6706 17.699 22.6631 17.6161 22.6568C17.5813 22.5812 17.5409 22.4938 17.4958 22.3956C17.3236 22.0209 17.0793 21.4898 16.7928 20.8658C16.2197 19.6177 15.4764 17.9961 14.7931 16.5038C14.4459 15.7363 13.6254 15.3272 12.8249 15.4708Z"
        fill="#99BCFF"
        stroke="url(#paint3_linear_24407_9630)"
        strokeWidth="1.24048"
      />
      <path
        d="M133.254 38.9355C132.904 38.816 132.521 38.945 132.317 39.2588C131.915 39.8712 131.478 40.5365 131.142 41.0486C130.974 41.3044 130.831 41.5222 130.73 41.6759C130.704 41.716 130.68 41.752 130.659 41.7829C130.622 41.7801 130.579 41.7777 130.53 41.774C130.347 41.7602 130.087 41.7402 129.782 41.7172C129.171 41.671 128.377 41.611 127.647 41.5551C127.284 41.527 126.94 41.7453 126.819 42.0993C126.701 42.4461 126.836 42.8361 127.142 43.0369C127.755 43.4384 128.42 43.8756 128.932 44.2121C129.188 44.3801 129.406 44.5228 129.559 44.6239C129.6 44.6507 129.637 44.6744 129.668 44.695C129.665 44.7319 129.661 44.7746 129.658 44.8225C129.644 45.0055 129.624 45.2647 129.601 45.5698C129.555 46.18 129.495 46.9739 129.439 47.7067C129.411 48.0702 129.629 48.4145 129.984 48.5352C130.331 48.6531 130.72 48.518 130.92 48.2115C131.323 47.5965 131.76 46.9312 132.096 46.4198C132.264 46.1642 132.407 45.9468 132.508 45.7935C132.534 45.7533 132.558 45.7174 132.578 45.6865C132.615 45.6893 132.659 45.6927 132.707 45.6963C132.89 45.7101 133.15 45.7301 133.455 45.7531L135.59 45.9152C135.956 45.9434 136.3 45.7169 136.419 45.3701C136.539 45.0159 136.4 44.6331 136.095 44.4334L134.305 43.2582C134.049 43.0902 133.832 42.9475 133.678 42.8464C133.638 42.82 133.602 42.7954 133.571 42.775C133.574 42.738 133.576 42.6949 133.58 42.6469C133.594 42.4635 133.614 42.2039 133.637 41.8987C133.683 41.2876 133.743 40.4937 133.799 39.7636C133.829 39.3892 133.598 39.0526 133.254 38.9355Z"
        fill="#99BCFF"
        stroke="url(#paint4_linear_24407_9630)"
        strokeWidth="0.553462"
      />
      <defs>
        <filter
          id="filter0_dd_24407_9630"
          x="25.502"
          y="6.31494"
          width="114.662"
          height="131.046"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24407_9630"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_24407_9630"
            result="effect2_dropShadow_24407_9630"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_24407_9630"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_0_24407_9630_clip_path"
          transform="translate(5.53125 25.6851)"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.7281 104.535L43.6947 104.367C41.1443 104.145 39.2691 101.921 39.4862 99.3897C40.7189 84.5948 44.6095 38.3301 45.8436 23.5337C46.0606 21.0021 48.28 19.1105 50.8304 19.3327C51.499 19.3895 52.1915 19.4481 52.8638 19.5002C56.0638 19.7712 59.0231 21.2978 61.0943 23.7492C61.0943 23.7492 71.1153 35.6059 75.5567 40.8595C76.8768 42.4226 78.7766 43.4049 80.8138 43.5678C89.4859 44.2975 103.916 45.5112 103.916 45.5112C115.48 46.483 124.063 56.6394 123.088 68.2006C123.102 68.2146 123.1 68.2177 123.1 68.2177C122.125 79.7788 111.969 88.3709 100.406 87.3991C100.406 87.3991 85.9758 86.1854 77.3037 85.4558C75.2513 85.2803 73.2296 85.9372 71.6569 87.2597C66.4025 91.6928 54.555 101.721 54.555 101.721C52.0916 103.785 48.928 104.806 45.7281 104.535Z"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_24407_9630"
          x1="20.2387"
          y1="102.151"
          x2="38.0243"
          y2="133.703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.572115" stopColor="#C5D9FF" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_24407_9630"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.5 62) rotate(16.5948) scale(78.7813 82.6564)"
        >
          <stop stopColor="white" />
          <stop offset="0.177885" stopColor="#F8F8F9" />
          <stop offset="0.519231" stopColor="#DAE5FB" />
          <stop offset="0.687994" stopColor="#BDD2FD" />
          <stop offset="1" stopColor="#99BCFF" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_24407_9630"
          x1="29.4196"
          y1="10.9033"
          x2="133.5"
          y2="93.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.25419" stopColor="#FCFCFC" />
          <stop offset="0.698291" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_24407_9630"
          x1="10.9106"
          y1="14.0514"
          x2="36.3406"
          y2="64.291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.572115" stopColor="#C5D9FF" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_24407_9630"
          x1="132.814"
          y1="37.9672"
          x2="131.877"
          y2="63.0729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.572115" stopColor="#C5D9FF" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
